import { render, staticRenderFns } from "./behaviour-biting-section.vue?vue&type=template&id=418183f5&scoped=true"
import script from "./behaviour-biting-section.vue?vue&type=script&lang=js"
export * from "./behaviour-biting-section.vue?vue&type=script&lang=js"
import style0 from "./behaviour-biting-section.vue?vue&type=style&index=0&id=418183f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418183f5",
  null
  
)

export default component.exports